module.exports = __webpack_public_path__ + "img/result_txt_g.33be7965.png";